import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

// 样式常量（放在函数外，避免esbuild JSX解析歧义）
const s_card = { background: '#fff', borderRadius: 8, padding: 16, boxShadow: '0 2px 8px rgba(0,0,0,0.06)', textAlign: 'center' }
const s_modalOverlay = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 }
const s_modal = { background: '#fff', borderRadius: 8, padding: 24, width: 500, maxHeight: '80vh', overflow: 'auto' }
const s_formItem = { display: 'flex', flexDirection: 'column' }
const s_th = { padding: 12, textAlign: 'left', fontSize: 13, color: '#666' }
const s_td = { padding: 12, fontSize: 13 }
const s_btn = { padding: '4px 8px', border: 'none', borderRadius: 4, cursor: 'pointer', fontSize: 12 }

export default function Coupons() {
  const [coupons, setCoupons] = useState([])
  const [loading, setLoading] = useState(true)
  const [filter, setFilter] = useState('all')
  const [showModal, setShowModal] = useState(false)
  const [showCreate, setShowCreate] = useState(false)
  const [showDistribute, setShowDistribute] = useState(false)
  const [selectedCoupon, setSelectedCoupon] = useState(null)
  const [customers, setCustomers] = useState([])
  const [editingCoupon, setEditingCoupon] = useState(null)
  const [form, setForm] = useState({ name: '', type: '新人券', amount: 20, minAmount: 100, total: 100, validFrom: '', validTo: '' })

  useEffect(() => {
    fetch(`${API}/coupons`)
      .then(r => r.json())
      .then(d => { if (d.success) setCoupons(d.data || []) })
      .catch(e => { console.error(e) })
      .finally(() => setLoading(false))
  }, [])

  const handleAdd = () => {
    setEditingCoupon(null)
    setForm({ name: '', type: '新人券', amount: 20, minAmount: 100, total: 100, validFrom: new Date().toISOString().split('T')[0], validTo: '' })
    setShowModal(true)
  }

  const handleEdit = (c) => {
    setEditingCoupon(c)
    setForm({
      name: c.name || '', type: c.type || '新人券',
      amount: c.amount || 20, minAmount: c.minAmount || 100,
      total: c.total || 100,
      validFrom: c.validFrom || '', validTo: c.validTo || ''
    })
    setShowModal(true)
  }

  const handleSave = async () => {
    if (!form.name || !form.validFrom || !form.validTo) { alert('请填写完整信息'); return }
    try {
      const method = editingCoupon ? 'PUT' : 'POST'
      const url = editingCoupon ? `${API}/coupons/${editingCoupon.id}` : `${API}/coupons`
      const res = await fetch(url, {
        method, headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, status: 'active' })
      })
      const data = await res.json()
      if (data.success) {
        setShowModal(false)
        const refreshed = await fetch(`${API}/coupons`).then(r => r.json())
        if (refreshed.success) setCoupons(refreshed.data || [])
        alert(editingCoupon ? '修改成功' : '创建成功')
      } else { alert(data.error || '操作失败') }
    } catch { alert('操作失败') }
  }

  const handleDelete = async (id) => {
    if (!confirm('确定删除？')) return
    try {
      const res = await fetch(`${API}/coupons/${id}`, { method: 'DELETE' })
      const data = await res.json()
      if (data.success) { setCoupons(coupons.filter(c => c.id !== id)); alert('删除成功') }
    } catch {}
  }

  const handleToggle = async (c) => {
    const newStatus = c.status === 'active' ? 'inactive' : 'active'
    try {
      await fetch(`${API}/coupons/${c.id}`, {
        method: 'PUT', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ status: newStatus })
      })
      setCoupons(coupons.map(x => x.id === c.id ? { ...x, status: newStatus } : x))
      alert(newStatus === 'active' ? '已启用' : '已停用')
    } catch {}
  }

  const getTypeBadge = (type) => {
    const map = { 'new_user': { bg: '#52c41a22', color: '#52c41a', text: '新人券' }, 'festival': { bg: '#f5222d22', color: '#f5222d', text: '节日券' }, 'member': { bg: '#1890ff22', color: '#1890ff', text: '会员券' }, 'invite': { bg: '#722ed122', color: '#722ed1', text: '邀请券' } }
    const s = map[type] || { bg: '#f5f5f5', color: '#999', text: type }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: s.bg, color: s.color }}>{s.text}</span>
  }

  const getStatusBadge = (status) => {
    const map = { active: { bg: '#f6ffed', color: '#52c41a', text: '投放中' }, inactive: { bg: '#fff1f0', color: '#ff4d4f', text: '已停用' } }
    const s = map[status] || { bg: '#f5f5f5', color: '#999', text: status }
    return <span style={{ padding: '2px 8px', borderRadius: 10, fontSize: 11, background: s.bg, color: s.color }}>{s.text}</span>
  }

  const filtered = filter === 'all' ? coupons : coupons.filter(c => c.status === filter)

  if (loading) return <div style={{ padding: 40, textAlign: 'center' }}>加载中...</div>

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>🎟 优惠券管理</h2>

      {/* 统计卡片 */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <div style={s_card}><div style={{ color: '#999', fontSize: 12 }}>优惠券总数</div><div style={{ fontSize: 28, color: '#1890ff', fontWeight: 600 }}>{coupons.length}</div></div>
        <div style={s_card}><div style={{ color: '#999', fontSize: 12 }}>投放中</div><div style={{ fontSize: 28, color: '#52c41a', fontWeight: 600 }}>{coupons.filter(c => c.status === 'active').length}</div></div>
        <div style={s_card}><div style={{ color: '#999', fontSize: 12 }}>已发放总数</div><div style={{ fontSize: 28, color: '#fa8c16', fontWeight: 600 }}>{coupons.reduce((s, c) => s + (c.total || 0), 0)}</div></div>
        <div style={s_card}><div style={{ color: '#999', fontSize: 12 }}>已使用</div><div style={{ fontSize: 28, color: '#722ed1', fontWeight: 600 }}>{coupons.reduce((s, c) => s + (c.used || 0), 0)}</div></div>
      </div>

      {/* 筛选和创建按钮 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        {['all', 'active', 'inactive'].map(f => (
          <button key={f} onClick={() => setFilter(f)} style={{ padding: '6px 16px', borderRadius: 20, border: 'none', cursor: 'pointer', fontSize: 13, background: filter === f ? '#1890ff' : '#f5f5f5', color: filter === f ? '#fff' : '#666' }}>
            {f === 'all' ? '全部' : f === 'active' ? '投放中' : '已停用'}
          </button>
        ))}
        <div style={{ flex: 1 }} />
        <button onClick={handleAdd} style={{ padding: '8px 20px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13 }}>+ 创建优惠券</button>
      </div>

      {/* 表格 */}
      <div style={{ background: '#fff', borderRadius: 8, overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead><tr style={{ background: '#fafafa' }}>
            <th style={s_th}>名称</th><th style={s_th}>类型</th><th style={s_th}>金额</th><th style={s_th}>门槛</th><th style={s_th}>已用/总量</th><th style={s_th}>有效期</th><th style={s_th}>状态</th><th style={s_th}>操作</th>
          </tr></thead>
          <tbody>
            {filtered.map(c => (
              <tr key={c.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                <td style={s_td}><div style={{ fontWeight: 500 }}>{c.name}</div></td>
                <td style={s_td}>{getTypeBadge(c.type)}</td>
                <td style={{ ...s_td, color: '#f5222d', fontWeight: 600 }}>¥{c.amount}</td>
                <td style={{ ...s_td, color: '#666' }}>满¥{c.minAmount}</td>
                <td style={s_td}><span style={{ color: '#52c41a' }}>{c.used || 0}</span><span style={{ color: '#999' }}>/{c.total || 0}</span></td>
                <td style={{ ...s_td, color: '#666', fontSize: 12 }}>{(c.validFrom || '').split('T')[0]}<br/>至 {(c.validTo || '').split('T')[0]}</td>
                <td style={s_td}>{getStatusBadge(c.status)}</td>
                <td style={s_td}>
                  <button onClick={() => handleEdit(c)} style={{ ...s_btn, background: '#1890ff', color: '#fff', marginRight: 4 }}>编辑</button>
                  <button onClick={() => { setSelectedCoupon(c); setShowDistribute(true) }} style={{ ...s_btn, background: '#52c41a', color: '#fff', marginRight: 4 }}>发放</button>
                  <button onClick={() => handleToggle(c)} style={{ ...s_btn, background: c.status === 'active' ? '#fa8c16' : '#52c41a', color: '#fff', marginRight: 4 }}>
                    {c.status === 'active' ? '停用' : '启用'}
                  </button>
                  <button onClick={() => handleDelete(c.id)} style={{ ...s_btn, background: '#ff4d4f', color: '#fff' }}>删除</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {filtered.length === 0 && <div style={{ padding: 40, textAlign: 'center', color: '#999' }}>暂无优惠券</div>}
      </div>

      {/* 创建/编辑弹窗 */}
      {showModal && (
        <div style={s_modalOverlay}>
          <div style={s_modal}>
            <h3 style={{ marginBottom: 16 }}>{editingCoupon ? '编辑优惠券' : '创建优惠券'}</h3>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>名称 *</label>
              <input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>类型</label>
              <select value={form.type} onChange={e => setForm({ ...form, type: e.target.value })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }}>
                <option value="新人券">新人券</option>
                <option value="节日券">节日券</option>
                <option value="会员券">会员券</option>
                <option value="邀请券">邀请券</option>
              </select>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>优惠金额</label>
                <input type="number" value={form.amount} onChange={e => setForm({ ...form, amount: Number(e.target.value) })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>使用门槛</label>
                <input type="number" value={form.minAmount} onChange={e => setForm({ ...form, minAmount: Number(e.target.value) })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>发放数量</label>
              <input type="number" value={form.total} onChange={e => setForm({ ...form, total: Number(e.target.value) })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>开始日期 *</label>
                <input type="date" value={form.validFrom} onChange={e => setForm({ ...form, validFrom: e.target.value })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
              <div>
                <label style={{ display: 'block', marginBottom: 4, fontSize: 13 }}>结束日期 *</label>
                <input type="date" value={form.validTo} onChange={e => setForm({ ...form, validTo: e.target.value })} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d9d9d9', borderRadius: 4 }} />
              </div>
            </div>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
              <button onClick={() => setShowModal(false)} style={{ padding: '8px 16px', border: '1px solid #d9d9d9', borderRadius: 4, background: '#fff' }}>取消</button>
              <button onClick={handleSave} style={{ padding: '8px 16px', background: '#1890ff', color: '#fff', border: 'none', borderRadius: 4 }}>保存</button>
            </div>
          </div>
        </div>
      )}

      {/* 发放弹窗 */}
      {showDistribute && selectedCoupon && (
        <div style={s_modalOverlay}>
          <div style={s_modal}>
            <h3 style={{ marginBottom: 16 }}>发放优惠券：{selectedCoupon.name}</h3>
            <p style={{ color: '#666', marginBottom: 16, fontSize: 13 }}>选择发放方式</p>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <button onClick={() => distributeToAll(selectedCoupon.id)} style={{ padding: 16, background: '#f6ffed', border: '1px solid #52c41a', borderRadius: 8, cursor: 'pointer', textAlign: 'left' }}>
                <div style={{ fontWeight: 500, color: '#52c41a' }}>📢 发放给所有客户</div>
                <div style={{ fontSize: 12, color: '#999', marginTop: 4 }}>自动发放给所有已注册客户</div>
              </button>
              <div style={{ padding: 16, background: '#fafafa', border: '1px solid #ddd', borderRadius: 8 }}>
                <div style={{ fontWeight: 500, marginBottom: 8 }}>👥 发放给指定客户</div>
                <div style={{ fontSize: 12, color: '#999', marginBottom: 8 }}>已加载 {customers.length} 位客户</div>
                <select id="customerSelect" multiple style={{ width: '100%', height: 120, padding: 8, borderRadius: 6 }}>
                  {customers.map(c => <option key={c.id} value={c.id}>{c.name} - {c.parentPhone || c.phone}</option>)}
                </select>
                <button onClick={() => { const sel = document.getElementById('customerSelect'); const ids = Array.from(sel.selectedOptions).map(o => o.value); distributeToSelected(selectedCoupon.id, ids) }} style={{ marginTop: 8, width: '100%', padding: 8, background: '#1890ff', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer' }}>确认发放</button>
              </div>
            </div>
            <button onClick={() => setShowDistribute(false)} style={{ marginTop: 16, width: '100%', padding: 10, background: '#f5f5f5', border: 'none', borderRadius: 6, cursor: 'pointer' }}>关闭</button>
          </div>
        </div>
      )}
    </div>
  )
}
